import React, { Component } from "react";
import "./fddetailpage.css";
import { t } from "i18next";
import {
  BreadCrumb,
  Button,
  FloatingLabelInput,
  Slider,
  TitleView,
  ToggleSwitch,
  SideModel,
  Toast,
  ProgressDialog,
} from "../../components";
import * as Bl from "../../../businesslogic";
import { getCurrentYear } from "../../utils/datetime";
import { getFinancialNonMarketPath, calculate_age, getUserDOB } from "../../common";
import * as logger from "../../utils/logger/index";
import { DEFAULT_OFFSET } from "../../constants";
import { getCurrentAge } from "../../utils/common";

class FDDetailPage extends Component {
  constructor(props) {
    super(props);
    const params = props.location.state;
    const investmentData = params?.investmentData ? params.investmentData : "";
    const isEditView = params?.isEditView ? params.isEditView : false;
    this.state = {
      startValue: getCurrentYear() + 1,
      maturityAge: getCurrentYear() + 1,
      investmentsData: investmentData ? new Bl.Investment(investmentData) : {},
      bankName: investmentData?.investmentdetails[0]?.bankname
        ? investmentData.investmentdetails[0].bankname
        : "",
      bankAccountNo: investmentData?.investmentdetails[0]?.bankaccountnumber
        ? investmentData.investmentdetails[0].bankaccountnumber
        : "",
      fliberAdvise: investmentData?.investmentdetails[0]?.isfliberadvise
        ? investmentData?.investmentdetails[0]?.isfliberadvise
        : false,
      isEditView,
      currentAge: 0,
    };
    this.isRenderingAlready = false;
    this.dbData = investmentData
      ? JSON.parse(JSON.stringify(new Bl.Investment(investmentData)))
      : {};
  }
  componentDidMount() {
    if (!this.isRenderingAlready) {
      this.isRenderingAlready = true;
      this.getCurrentAge();
    }
  }

  getCurrentAge() {
    const data = { dob: getUserDOB(), offset: DEFAULT_OFFSET }
    this.setState({ showProgress: true }, () => {
      getCurrentAge(data)
        .then((response) => {
          const currentAge = response.currentage;
          const investmentObj = this.state.investmentsData;
          investmentObj.setUserAge(currentAge);
          this.setState({
            currentAge: currentAge,
            showProgress: false,
          });
        })
        .catch((error) => {
          console.log("FixedDepositDetailsPage.js/getCurrentAge Error:", error);
          this.showToast(t("someErrorHasOccured"));
        });
    });
  }
  onSelectItem(path) {
    const localData = new Bl.Investment(this.state.investmentsData);
    localData.revertAllChanges();
    this.setState(
      {
        bankName: this.dbData?.investmentdetails[0]?.bankname
          ? this.dbData.investmentdetails[0].bankname
          : "",
        bankAccountNo: this.dbData?.investmentdetails[0]?.bankaccountnumber
          ? this.dbData.investmentdetails[0].bankaccountnumber
          : "",
        fliberAdvise: this.dbData?.investmentdetails[0]?.isfliberadvise
          ? this.dbData?.investmentdetails[0]?.isfliberadvise
          : false,
      },
      () => {
        this.props.navigate(path);
      }
    );
  }

  checkIsDataValid(data) {
    let isValid = true;
    const invesmentDetails = data?.investmentdetails[0]
      ? data.investmentdetails[0]
      : "";
    let message = "";
    if (!this.isBankNamevalid(invesmentDetails.bankname)) {
      isValid = false;
      message = t("fixedDepositToastBankName");
    } else if (!this.isBankAccNoValid(invesmentDetails.bankaccountnumber)) {
      isValid = false;
      message = t("fixedDepositToastBankAccNumber");
    } else if (!this.isAmountValid(data.currentvalue)) {
      isValid = false;
      message = t("FD: Please enter the Investment Amount")
    } else if (!this.isAmountValid(data.maturityvalue)) {
      isValid = false;
      message = t("fixedDepositToastMaturityValue");
    } else if (!this.isMaturityYearValid(data.maturityyear)) {
      isValid = false;
      message = t("fixedDepositToastMaturityYear");
    }
    return { isValid, message };
  }

  isBankNamevalid(bankname) {
    return bankname && bankname.length > 0;
  }

  isBankAccNoValid(bankaccountnumber) {
    return bankaccountnumber && bankaccountnumber.length === 4;
  }
  isAmountValid(amount) {
    return amount && amount > 0;
  }
  isMaturityYearValid(maturityyear) {
    return maturityyear !== 0;
  }

  prepareBanksData() {
    const fields = {
      bankname: this.state.bankName || "",
      bankaccountnumber: this.state.bankAccountNo || "",
      isfliberadvise: this.state.fliberAdvise,
    };
    const bankDetails = [];
    const bankDetail = {};
    let oneFieldAvail = false;
    Object.keys(fields).forEach((key) => {
      if (fields[key] !== "") {
        oneFieldAvail = true;
        bankDetail[key] = fields[key];
      }
    });
    if (oneFieldAvail) {
      bankDetails.push(bankDetail);
    }
    return { bankDetails };
  }

  createUserInvestment(data) {
    const currentYear = getCurrentYear();
    const investmentData = this.state.investmentsData;
    const startValue = investmentData?.maturityyear
      ? investmentData.maturityyear
      : currentYear + 1;
    const maturityAge = calculate_age(startValue, currentYear, this.state.currentAge)
    const investmentObj = new Bl.Investment(this.state.investmentsData);
    if (investmentObj.maturityyear === 0) {
      investmentObj.setMaturityYear(getCurrentYear() + 1);
      investmentObj.setMaturityAge(maturityAge)
    }
    investmentObj.setInvestmentDetails(data.bankDetails);
    const isDataValid = this.checkIsDataValid(investmentObj);
    console.log({ investmentObj })
    if (isDataValid.isValid) {
      this.setState({ showProgress: true }, () => {
        investmentObj
          .createInvestment()
          .then(() => {
            this.setState({ showProgress: false }, () => {
              this.props.navigate("/fddashboard");
            });
          })
          .catch((error) => {
            logger.error({ error });
            this.showToast(t("someErrorHasOccured"));
          });
      });
    } else {
      const toastMessage = isDataValid.message;
      this.showToast(toastMessage);
    }
  }

  updateUserInvestment(data) {
    const investmentObj = new Bl.Investment(this.state.investmentsData);
    investmentObj.setInvestmentDetails(data.bankDetails);
    const isDataValid = this.checkIsDataValid(investmentObj);
    if (isDataValid.isValid) {
      this.setState({ showProgress: true }, () => {
        investmentObj
          .updateInvestment()
          .then(() => {
            this.setState({ showProgress: false }, () => {
              this.props.navigate("/fddashboard");
            });
          })
          .catch((error) => {
            logger.error({ error });
            this.showToast(t("someErrorHasOccured"));
          });
      });
    } else {
      const toastMessage = isDataValid.message;
      this.showToast(toastMessage);
    }
  }

  onPressSaveButton() {
    const data = this.prepareBanksData();
    if (this.state.isEditView) {
      this.updateUserInvestment(data);
    } else {
      this.createUserInvestment(data);
    }
  }
  hideToast() {
    this.setState({ toastMessage: "", showToast: false });
  }

  showToast(toastMessage) {
    this.setState(
      { toastMessage, showToast: true, showProgress: false },
      () => {
        setTimeout(() => {
          this.hideToast();
        }, 3000);
      }
    );
  }
  onChangeBankName(value) {
    this.setState({ bankName: value }, () => {
      const data = this.prepareBanksData();
      const investment = this.state.investmentsData;
      investment.setInvestmentDetails(data.bankDetails);
    });
  }

  onChangeAccountNo(value) {
    this.setState({ bankAccountNo: value }, () => {
      const data = this.prepareBanksData();
      const investment = this.state.investmentsData;
      investment.setInvestmentDetails(data.bankDetails);
    });
  }

  onChangeInvestmentAmount(value) {
    const investment = this.state.investmentsData;
    investment.setCurrentValue(value ? Number(value) : 0);
    this.forceUpdate();
  }

  onChangeMaturityAmount(value) {
    const investment = this.state.investmentsData;
    investment.setMaturityValue(value ? Number(value) : 0);
    this.forceUpdate();
  }

  handleChangeStart(event) {
    const newValue = event.target.value;
    const investment = this.state.investmentsData;
    const currentYear = getCurrentYear();
    const maturityAge = calculate_age(newValue, currentYear, this.state.currentAge)
    investment.setMaturityYear(newValue ? Number(newValue) : newValue);
    investment.setMaturityAge(maturityAge)
    this.forceUpdate();
  }

  handleToggleSwitchChange(selectedItem, isSelected) {
    const investment = this.state.investmentsData;
    investment.setIsIncludeFinancialPlan(isSelected);
    this.forceUpdate();
  }

  handleFliberToggleSwitch(selectedItem, isSelected) {
    this.setState({ fliberAdvise: isSelected }, () => {
      const data = this.prepareBanksData();
      const investment = this.state.investmentsData;
      investment.setInvestmentDetails(data.bankDetails);
    });
  }

  renderNavView() {
    const items = getFinancialNonMarketPath("FD");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        dbData={this.dbData}
        localData={this.state.investmentsData}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("networthAssetsFNM2");
    return <TitleView title={title} />;
  }

  renderInputView(
    label,
    value,
    onChange,
    showRupeeSymbol = false,
    showPercentage = false,
    selectionView = false,
    selectedOptions = [],
    type = ""
  ) {
    return (
      <div className="fddp_input">
        <FloatingLabelInput
          label={label}
          value={value}
          showRupeeSymbol={showRupeeSymbol}
          showPercentage={showPercentage}
          onChangeValue={onChange}
          selectionView={selectionView}
          selectionOptions={selectedOptions}
          type={type}
        />
      </div>
    );
  }

  renderToggleView(label, checked, onChange) {
    return (
      <div className="fddp_toggle_view">
        <label className="fddp_toggle_text">{label}</label>
        <ToggleSwitch
          checkedChildren={t("fdToggle1")}
          unCheckedChildren={t("fdToggle2")}
          onChangeToggle={onChange}
          defaultChecked={checked}
          style={{ width: "60px" }}
        />
      </div>
    );
  }

  renderFDDetails() {
    const investmentData = this.state.investmentsData;
    const balance = investmentData?.maturityvalue
      ? investmentData?.maturityvalue
      : "";
    const current = investmentData?.currentvalue
      ? investmentData?.currentvalue
      : "";
    const bankname = this.state.bankName;
    const bankaccountnumber = this.state.bankAccountNo;
    return (
      <div className="fddp_description_view">
        <div className="fddp_input_row">
          {this.renderInputView(
            t("fdInputBankName"),
            bankname,
            this.onChangeBankName.bind(this)
          )}
          {this.renderInputView(
            t("fdInputAccountNo"),
            bankaccountnumber,
            this.onChangeAccountNo.bind(this),
            false,
            false,
            false,
            [],
            "number"
          )}
          <div className="fddp_sec_row">
            {this.renderInputView(
              t("FD: Investment Amount"),
              current,
              this.onChangeInvestmentAmount.bind(this),
              true
            )}
            {this.renderInputView(
              t("fdInputMaturityAmount"),
              balance,
              this.onChangeMaturityAmount.bind(this),
              true
            )}
          </div>
          {this.renderYearView(investmentData)}
        </div>
      </div>
    );
  }

  renderYearView(investmentData) {
    const currentYear = getCurrentYear();
    const maturityyear =
      investmentData && investmentData.maturityyear
        ? investmentData.maturityyear
        : getCurrentYear() + 1;
    const age = calculate_age(maturityyear, currentYear, this.state.currentAge);
    return (
      <div className="fddp_slider_view">
        <div className="fddp_start_year_row">
          <label className="fddp_start_text">{t("fdSlider")}</label>
          <div className="fddp_slider_content">
            <Slider
              value={maturityyear}
              age={age}
              min={getCurrentYear() + 1}
              max={getCurrentYear() + 61}
              markStep={10}
              handleChange={this.handleChangeStart.bind(this)}
              showAge={true}
            />
          </div>
        </div>
      </div>
    );
  }

  renderButtonsView() {
    return (
      <div className="fddp_bottomView">
        <div className="fddp_buttonView">
          <div className="fddp_save">
            <Button
              buttonName={t("fdButton1")}
              onPressButton={this.onPressSaveButton.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }

  renderContentView() {
    const investment = this.state.investmentsData;
    return (
      <div className="fddp_content_view">
        {this.renderTitleView()}
        {this.renderFDDetails()}
        <div className="fddp_seperatorStyle" />
        <div className="fddp_retirement_toggle">
          {this.renderToggleView(
            t("fdTg1Text"),
            investment?.isincludefinancialplan,
            this.handleToggleSwitchChange.bind(this)
          )}
          {this.renderToggleView(
            t("Fliber Advised"),
            this.state.fliberAdvise,
            this.handleFliberToggleSwitch.bind(this)
          )}
        </div>
      </div>
    );
  }

  renderToastView() {
    return (
      <Toast
        showToast={this.state.showToast}
        toastMessage={this.state.toastMessage}
      />
    );
  }
  renderProgressDialog() {
    return (
      <ProgressDialog
        showProgress={this.state.showProgress}
        progressMessage={this.state.progressMessage}
      />
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  render() {
    return (
      <div className="fddp_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {this.renderButtonsView()}
        {/* {this.renderDrawerContent()} */}
        {this.renderToastView()}
        {this.renderProgressDialog()}
      </div>
    );
  }
}

export default FDDetailPage;
